module.exports = __webpack_public_path__ + "static/the-female-brain-58b021c177beb04fd92dfb73d87c9195.jpg";